import React from 'react';
import { HiOutlineMail } from 'react-icons/hi'
import { SiSlack } from 'react-icons/si'
import { BsLinkedin } from 'react-icons/bs'
import './contact.css'
const Contact = () => {
  return (
    <section id="contact" className="nav-link contact">
      <h2>Contact Me</h2>
      <div className='container contact_container'>
        <div className='contact_options'>
          <article className='contact_option'>
            <HiOutlineMail className='contact_option-icon' />
            <h4>Email</h4>
            <h5 id="email">pritampritamhalder@gmail.com</h5>
            <a href="mailto:pritampritamhalder@gmail.com" target="_blank" className='link_btn' style={{color:"white"}}>Send a Message</a>
          </article>
          <article className='contact_option'>
            <SiSlack className='contact_option-icon' />
            <h4>Slack</h4>
            <h5>Pritam Halder</h5>
            <a href="https://app.slack.com/client/T04QH584W4W/C04R2C5U2JV/rimeto_profile/U04RXUHTEBT?force_cold_boot=1" target="_blank" className='link_btn' style={{color:"white"}}>Send a Message</a>
          </article>
          <article className='contact_option'>
            <BsLinkedin className='contact_option-icon' />
            <h4>Linkedin</h4>
            <h5>Pritam Halder</h5>
            <a href="https://www.linkedin.com/in/pritamhalder62/" target="_blank" className='link_btn'style={{color:"white"}}>Send a Message</a>
          </article>
        </div>
        <form action="https://formspree.io/f/xwkjnnyd" method="POST">
          <input type="text" name='name' placeholder='Your Full Name' required />
          <input type="email" name='email' placeholder='Your Email' required />
          <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  );
}

export default Contact;
